import {DNA} from 'react-loader-spinner'
import React from "react";

function Loader(){
    return <DNA wrapperClass="loader-spinner"  width={150} height={150}/>
}

export default Loader;